export const AGENT_PURPOSES = [
  "APPOINTMENT", "RESCHEDULE", "CANCELLATION", "MESSAGE_OTHER", "BLOOD_WORK_REQUISITION",
];

export const COLLECTION_TOPICS = [
  "name", "phone", "email", "insurance", "date_of_birth",
  "address", "reason", "appointment_time", "returning",
];

export const RUN_STATUSES = ["queued", "running", "done", "error", "skipped"];

export const ASSERTION_TYPES = [
  {
    value: "questions_collected",
    label: "Questions collected",
    param: "topics",
    help: "Passes if the agent successfully collected ALL of the selected topics from the caller during the call.",
  },
  {
    value: "not_re_asked",
    label: "Not re-asked",
    param: "topic",
    help: "Passes if the agent did NOT ask again for a topic the caller already provided (no annoying repeats).",
  },
  {
    value: "out_of_hours_refused",
    label: "Out-of-hours refused",
    param: null,
    help: "Passes if the agent correctly refused to book when the requested time is outside the clinic's opening hours. No parameters needed.",
  },
  {
    value: "no_booking_confirmed",
    label: "No booking confirmed",
    param: null,
    help: "Passes if the agent did NOT confirm a booking (e.g. for cancellation or info-only scenarios). No parameters needed.",
  },
];

export const assertionHelp = (type) =>
  ASSERTION_TYPES.find((t) => t.value === type)?.help || "";

const STATUS_BADGES = {
  queued: { label: "Queued", className: "bg-gray-100 text-gray-700" },
  running: { label: "Running", className: "bg-blue-100 text-blue-700" },
  done: { label: "Done", className: "bg-green-100 text-green-700" },
  error: { label: "Error", className: "bg-red-100 text-red-700" },
  skipped: { label: "Skipped", className: "bg-amber-100 text-amber-700" },
};

export const badgeForStatus = (status) =>
  STATUS_BADGES[status] || { label: status, className: "bg-gray-100 text-gray-700" };

export const isFailedRun = (run) =>
  !!run && (run.status === "error" || (run.scenarios_failed || 0) > 0);
